import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles(() => ({
  custom_input: {
    '& .MuiOutlinedInput-root.MuiOutlinedInput-root.MuiOutlinedInput-root .MuiOutlinedInput-input': {
      padding: '7px 10px'
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-marginDense': {
      transform: 'translate(14px, 8px) scale(1)'
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      transform: 'translate(12px, -6px) scale(0.75)'
    },
    '& .MuiFormHelperText-contained': {
      marginLeft: '0',
      marginRight: '0'
    }
  },
  custom_datepicker: {
    '& .MuiOutlinedInput-root': {
      marginBottom: '15px'
    },
    '& .MuiOutlinedInput-adornedStart': {
      paddingLeft: '0'
    },
    '& .MuiInputAdornment-positionStart': {
      marginRight: '0'
    }
  },
  no_margin: {
    '& .MuiFormHelperText-contained': {
      marginLeft: '0',
      marginRight: '0'
    }
  },
}));

export default useStyles;

